type AnalyticsLoadListener = () => void

const listeners = new Set<AnalyticsLoadListener>()
let analyticsLoadRequested = false

export function requestAnalyticsLoad(): void {
  if (analyticsLoadRequested) {
    return
  }

  analyticsLoadRequested = true

  for (const listener of listeners) {
    listener()
  }
}

export function onAnalyticsLoadRequested(
  listener: AnalyticsLoadListener
): () => void {
  listeners.add(listener)

  if (analyticsLoadRequested) {
    listener()
  }

  return () => {
    listeners.delete(listener)
  }
}

export function resetAnalyticsLoadRequestForTests(): void {
  analyticsLoadRequested = false
  listeners.clear()
}
